import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type {
  AccountPopulationReport,
  ReportableOrg,
} from '@/lib/api/domains/reports';
import { keys } from '@/lib/query-keys';

/*
 * The organizations the account-population report may be read for (F02 R39,
 * AC-832c0d75). How the report surface CONSUMES the scoped org list: the
 * selector's options. The server scopes it; the surface renders exactly these
 * and never widens them. Each option's value is an opaque org id (no PII).
 */
export function reportableOrgsQuery() {
  return queryOptions<ReportableOrg[]>({
    queryKey: keys.reports.organizations(),
    queryFn: () => api.reports.listReportableOrgs(),
  });
}

/*
 * The account-population report read (F02 R39). How the UI CONSUMES the
 * `GET /reports/access/account-population` transport: the queryOptions the
 * Administrator-gated report surface reads.
 *
 * Keyed by the organization id the report is read FOR, so Kelly's own org and a
 * named other org are cached and read SEPARATELY (AC-832c0d75) — switching the
 * selected org reads a different key, never a mingled figure. The org id is an
 * OPAQUE id (never a name): no PII enters the query key, the request URL or
 * telemetry (AGENTS.md: ids only). The server scopes the counts to that one org
 * and gates the whole route on the is_administrator privilege (AC-02d2e999);
 * the frontend only withholds the way in (the courtesy half) and renders the
 * counts the server returns.
 */
export function accountPopulationReportQuery(organizationId: string) {
  return queryOptions<AccountPopulationReport>({
    queryKey: keys.reports.accountPopulation(organizationId),
    queryFn: () => api.reports.accountPopulation(organizationId),
  });
}
